// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"task"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M20 22V4H16V6H8V4H4V22H20Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M16 6H8V2H16V6Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 4H20V22H4V4H8M16 4V2H8V4M16 4V6H8V4","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10 12H14M10 16H14","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TaskIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'task',
    ref,
    icon: element,
  },
));

TaskIcon.displayName = 'TaskIcon';

export default TaskIcon;
